type TPromiseWithResolvers<T> = {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
};

type TPromiseConstructorWithResolvers = PromiseConstructor & {
  withResolvers?: <T>() => TPromiseWithResolvers<T>;
};

const promiseConstructor = Promise as TPromiseConstructorWithResolvers;

if (!promiseConstructor.withResolvers) {
  promiseConstructor.withResolvers = <T>() => {
    let resolve!: TPromiseWithResolvers<T>["resolve"];
    let reject!: TPromiseWithResolvers<T>["reject"];
    const promise = new Promise<T>((promiseResolve, promiseReject) => {
      resolve = promiseResolve;
      reject = promiseReject;
    });

    return { promise, resolve, reject };
  };
}

export {};
